<div class="account-setup">
  <div>
    <div class="step-text"></div>
    <div class="col-12">
      <div class="header-text heading" role="heading" aria-level="1">
        <adp-label *ngIf="!showOtpScreen" labelKey="Signup_InvitedUser_ExtraInfo_Heading_Text"></adp-label>
        <adp-label *ngIf="showOtpScreen" labelKey="Signup_Create_Account_VerifyOTP_Heading_Text"></adp-label>
      </div>
    </div>
    <div class="password-container">
      <div *ngIf="!showOtpScreen">
        <form [formGroup]="extraInformationForm" (ngSubmit)="createOtp()">
          <div class="row mb-3 extra-info-form">
            <div class="col-12">
              <p class="pass-text">
                <adp-label labelKey="Signup_InvitedUser_ExtraInfo_Instruction_Text"></adp-label>
              </p>
              <adp-input class="w-100" formControlName="firstName"
                [resourceData]="firstNameResourceData" ></adp-input>
              <adp-input class="w-100" formControlName="lastName"
                [resourceData]="lastNameResourceData"></adp-input>
              <adp-input class="w-100" formControlName="phoneNumber"
                [resourceData]="phoneNumberResourceData"></adp-input>
            </div>
          </div>
          <div class="footer-btn">
            <div class="col-12">
              <div class="form-group  mb-3">
                <button mat-flat-button color="accent" type="submit" [disabled]="!extraInformationForm.valid">
                  <adp-label labelKey="Signup_InvitedUser_ExtraInfo_SubmitButton_Text"></adp-label>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div *ngIf="showOtpScreen">
        <app-verify-otp [otpRequest]="otpRequest"
          [lookupResponse]="{}"
          [isSecondaryMemberInvite]="true"
          (verifyOTPResponse)="verifyOtp($event)">
        </app-verify-otp>
      </div>
    </div>
  </div>
</div>
